import axios from 'axios';
import { keycloak,KeycloakService } from './KeyCloakService';

const axiosCat =  axios.create({
  baseURL: process.env.REACT_APP_CAT_EP,
  timeout: 10000  
});
axiosCat.interceptors.request.use (
  function (config) {
    const token = keycloak.token;
    if (token) config.headers.Authorization = 'Bearer '+token;
    return config;
  },
  function (error) {
    return Promise.reject (error);
  }
);
axiosCat.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      // Use Keycloak's updateToken method
      // minValidity: 5 means "if the token expires in less than 5 seconds, refresh it"
      keycloak.updateToken(5).then((refreshed) => {
        if (refreshed) {
          // Token was refreshed! Retry the original request with new token
          const newToken = keycloak.token;
          error.config.headers.Authorization = `Bearer ${newToken}`;
          return axios(error.config);
        } else {
          // Token is still valid but we got a 401? Force login.
          keycloak.login();
        }
      }).catch(() => {
        // Refresh token failed/expired
        keycloak.login();
      });
    }
    return Promise.reject(error);
  }
);
class CatService
{
  static async getCats(parentId,catType)
  {
    console.log("getCats:"+parentId);
    if(parentId != undefined && parentId != '')
    {
      const res = await axiosCat.get('cats/' + parentId + '/children?catType=' + catType);
      return res.data;
    }
    else
    {
      const res_1 = await axiosCat.get('roots');
      return res_1.data;
    }
  }
  static async getChildRels(parentId,catType)
  {
    console.log("getChildRels:"+parentId);
    const res = await axiosCat.get('cats/' + parentId + '/rels?catType=' + catType);
    return res.data;
  }
 
  static async getCatTree(parentId,catType,addRoot)
  {
    console.log("getAllCats:"+parentId);
    var url=(parentId!=null && parentId!=0)?'cats/'+parentId+'/tree?d=1':'cats/tree?d=1';

    if(catType != undefined) url=url+"&catType="+catType;
    if(addRoot != undefined && addRoot) url=url+"&addRoot=true";

    const res = await axiosCat.get(url);
    return res.data;
  }
  static async getCatChain(catId)
  {
    const res = await axiosCat.get('cats/' + catId + '/chain');
    return res.data;
  }
  static async getProg(catId)
  {
    const res = await axiosCat.get('cats/' + catId + '/chain');
    let rt=res.data.at(-1);
    console.log("prog:"+JSON.stringify(rt));
    return rt;
  }
  static getCat(id)
  {
    return axiosCat.get('cats/'+id);
  }
  static getCatStats()
  {
    return axiosCat.get('cats/stats');
  }
  static async insertCat(parentId,cat,catType)
  {
    console.log("insertCat:parent="+parentId+" cat="+JSON.stringify(cat));
    if(parentId == undefined)
      parentId = null;
    cat.catType=catType;
    cat.parentId=parentId;
    cat.id = null;
    const res = await axiosCat.post('cats', cat);
    return res.data;
  }
  static async addCatRel(parentId,childId,weight)
  {
    var rel={parentId:parentId,childId:childId,weight:weight};
    const res = await axiosCat.post('cats/' + parentId + '/rels', rel);
    return res.data;
  }
  static async removeCatRel(id)
  {
    const res = await axiosCat.delete('rels/' + id);
    return res.data;
  }
  static async insertCats(parentId,cats,catType)
  {
    if(parentId == undefined)
      parentId = null;

    cats.forEach(cat => {
      cat.id = null
      cat.catType = catType;
      cat.parentId = parentId;
    });
    const res = await axiosCat.post('cats/' + parentId + '/children', cats);
    return res.data;
  }
  static async updateCat(cat)
  {
    console.log("updateCat: cat="+JSON.stringify(cat));
    const res = await axiosCat.post('cats/' + cat.id, cat);
    return res.data;
  }
  static async deleteCat(cat)
  {
    const res = await axiosCat.delete('cats/' + cat.id);
    return res.data;
  }
  static async getUdfByEntity(entity)
  {
    const res = await axiosCat.get('udfs/' + entity);
    return res.data;
  }
  static async insertUdf(udf)
  {
    const res = await axiosCat.post('udfs', udf);
    return res.data;
  }
  static async updateUdf(udf)
  {
    const res = await axiosCat.post('udfs/' + udf.id, udf);
    return res.data;
  }
  static async searchPerms(searchCrt)
  {
    const res = await axiosCat.post('perms/search', searchCrt);
    return res.data;
  }
  static async getCatPerms(catId)
  {
    const res = await axiosCat.get('cats/' + catId + '/perms');
    return res.data;
  }
  static async insertPerm(perm)
  {
    const res = await axiosCat.post('perms', perm);
    return res.data;
  }
  static async deletePerms(ids)
  {
    var idlist={ids:ids};
    const res = await axiosCat.post('perms/deleteMulti', idlist);
    return res.data;
  }
  static async getCatLogs(catId)
  {
    const res = await axiosCat.get('cats/' + catId + '/logs');
    return res.data;
  }
  static async getProgs()
  {
    const res = await axiosCat.get('progs');
    return res.data;
  }
  static async importProg(progCode)
  {
    const formData = new FormData();    
    formData.append("progCode",progCode);
    const res = await axiosCat.post('progs/load', formData);
    return res.data;
  }
  static async getProc(id)
  {
    return axiosCat.get('procs/'+id).then(res => res.data);
  }  
  static async getWrks()
  {
    const res = await axiosCat.get('wrks');
    return res.data;
  }
  static async chkinWrk(id)
  {
    return axiosCat.post('wrks/'+id+'/chkin').then(res=>res.data);
  }
}
export default CatService;
